
export const LanguageChecker = () => {
    const webSrn = localStorage.getItem('WebSrn')
    const farsi = webSrn == 14  ||  webSrn == 13

    return farsi
}